import LoadingIndicator from '@storeblocks/loading-indicator';
import { isAuthenticated, login } from 'Components/KeycloakWrapper';
import React from 'react';

export const Authenticated = ({
  children,
}: React.PropsWithChildren): React.ReactElement | null => {
  if (!isAuthenticated()) {
    login();
    return <LoadingIndicator />;
  }

  return <>{children}</>;
};
